import { createContext, useContext } from "react";

import type { TextEditorContextValue } from "./TextEditor.types";

export function makeTextEditorContext({
  editor = null,
  size = "md",
  disabled = false,
  setToolbarHeld = () => {},
}: Partial<TextEditorContextValue>): Required<TextEditorContextValue> {
  return { editor, size, disabled, setToolbarHeld };
}

export const TextEditorContext = createContext<
  Required<TextEditorContextValue>
>(makeTextEditorContext({}));

export function useTextEditorContext() {
  return useContext(TextEditorContext);
}
